import { render, staticRenderFns } from "./index_v5.vue?vue&type=template&id=412c4dc4&scoped=true&"
import script from "./index_v5.vue?vue&type=script&lang=js&"
export * from "./index_v5.vue?vue&type=script&lang=js&"
import style0 from "./index_v5.vue?vue&type=style&index=0&id=412c4dc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412c4dc4",
  null
  
)

/* custom blocks */
import block0 from "./index_v5.vue?vue&type=custom&index=0&blockType=div&class=list-item_box"
if (typeof block0 === 'function') block0(component)

export default component.exports